import React, { useState } from 'react';
import api from '../api';
import Card, { CardBody, CardFooter } from './ui/Card';
import Input from './ui/Input';
import Button from './ui/Button';
import './Auth.css';

function Register({ onRegisterSuccess, onSwitchToLogin }) {
    const [formData, setFormData] = useState({
        username: '',
        password: '',
        confirmPassword: '',
        email: ''
    });
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        if (formData.password !== formData.confirmPassword) {
            setError('Passwords do not match');
            setLoading(false);
            return;
        }

        try {
            const response = await api.post('/register/', {
                username: formData.username,
                password: formData.password,
                email: formData.email
            });
            localStorage.setItem('authToken', response.data.token);
            localStorage.setItem('username', response.data.username);
            localStorage.setItem('userId', response.data.user_id);
            onRegisterSuccess(response.data);
        } catch (err) {
            setError(err.response?.data?.error || 'Registration failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <Card variant="glass" padding="none" className="auth-card animate-scale-in">
                <CardBody>
                    <div className="auth-header">
                        <div className="auth-icon">✨</div>
                        <h2>Join the Adventure</h2>
                        <p className="auth-subtitle">Create your account to start collecting</p>
                    </div>

                    <form onSubmit={handleSubmit} className="auth-form">
                        {error && (
                            <div className="alert alert-error">
                                <span className="alert-icon">⚠️</span>
                                <span>{error}</span>
                            </div>
                        )}

                        <Input
                            label="Username"
                            type="text"
                            leftIcon="👤"
                            value={formData.username}
                            onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                            required
                            autoFocus
                            placeholder="Choose a username"
                        />

                        <Input
                            label="Email"
                            type="email"
                            leftIcon="📧"
                            value={formData.email}
                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                            placeholder="your.email@example.com (optional)"
                            hint="Optional - for account recovery"
                        />

                        <Input
                            label="Password"
                            type="password"
                            leftIcon="🔒"
                            value={formData.password}
                            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                            required
                            placeholder="Create a strong password"
                        />

                        <Input
                            label="Confirm Password"
                            type="password"
                            leftIcon="🔒"
                            value={formData.confirmPassword}
                            onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                            required
                            placeholder="Re-enter your password"
                        />

                        <Button
                            type="submit"
                            variant="primary"
                            size="lg"
                            fullWidth
                            loading={loading}
                            className="auth-submit-btn"
                        >
                            Create Account
                        </Button>
                    </form>
                </CardBody>

                <CardFooter>
                    <div className="auth-footer">
                        <span>Already have an account?</span>
                        <Button
                            variant="link"
                            onClick={onSwitchToLogin}
                        >
                            Sign In
                        </Button>
                    </div>
                </CardFooter>
            </Card>
        </div>
    );
}

export default Register;
